export default __webpack_public_path__ + "static/2-03e0a890353efb1ed3fac8ce385bbdbd.svg";